import React, {useCallback, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import SMCTable from '../../components/core/SMCTable/SMCTable';
import RowLayout from '../../components/Layouts/RowLayout';
import SMCButton from '../../components/Simple/SMCButton';
import SMCLabel from '../../components/Simple/SMCLabel';
import {dateAndTimeToString} from '../../utils/utils';
import UserIcon from '../../assets/images/owner.png';
import AdminIcon from '../../assets/images/admin.png';
import Api from '../../api/SMPFetchHelper';

const UserTypeCell = React.memo(({value}) => {
    switch (value) {
        case 'User':
            return <img src={UserIcon} alt="" />;
        case 'Administrator':
            return <img src={AdminIcon} alt="" />;
        default:
            return <img src={AdminIcon} alt="" />;
    }
});

const LoginDateCell = React.memo(({value}) => {
    return dateAndTimeToString(value, true);
});


function SessionTab() {
    const { t } = useTranslation();

    const [userSessions, setUserSession] = useState(null);
    const [isFetchingUserSessions, setIsFetchingUserSessions] = useState(false);
    const [errorFetchingUserSessions, setErrorFetchingUserSessions] = useState(false);

    const loadSessionsData = useCallback(() => {
        setIsFetchingUserSessions(true);
        Api.getSessions()
        .then(getSessionsResp => {
            setUserSession(getSessionsResp.data.data);
            setErrorFetchingUserSessions(false);
        })
        .catch(() => {
            setErrorFetchingUserSessions(true);
        })
        .finally(() => {
            setIsFetchingUserSessions(false);
        });
    }, []);
    
    useEffect(() => {
        loadSessionsData();
    }, [loadSessionsData]);

    const columns = [
        { id: 'userType',    accessor: 'userType',      header: '',                            width: 30,  align: 'center', Cell: UserTypeCell  },
        { id: 'userId',      accessor: 'userUid',       header: t('SMC_USER_UID'),             width: 97                                        },
        { id: 'loginDate',   accessor: 'loginTime',     header: t('SMC_OBJECT_LOGINTIME'),     width: 173,                  Cell: LoginDateCell },
        { id: 'application', accessor: 'appName',       header: t('SMC_WELCOME_SESSIONS_APP'), width: 112                                       },
        { id: 'sourceIp',    accessor: 'remoteAddress', header: t('SMC_WELCOME_SESSIONS_IP'),  width: 117                                       }
    ];

    return (
        <div>
            <RowLayout style={{ padding: '4px' }} height={30}>
                <SMCButton variant="ghost" icon="refresh" onClick={loadSessionsData} />
                |&nbsp;
                {
                    !errorFetchingUserSessions ? (
                        <SMCLabel inline>Showing {userSessions ? userSessions.length : 0} results</SMCLabel>
                    ) : (
                        <SMCLabel inline>Error fetching sessions, please try again</SMCLabel>
                    )
                }
            </RowLayout>
            <SMCTable
                columns={columns}
                width={550}
                height={450}
                hasCheckboxColumn={false}
                content={userSessions}
                loading={isFetchingUserSessions}
            />
        </div>
    );
}

export default SessionTab;